export enum DeleteReferenceModelNodesStatusEnum {
  IN_PROGRESS = 'inProgress',
  COMPLETED = 'completed',
  FAILED = 'failed'
}
